import "./App.css";
import React from "react";
import Header from "./componets/Header";
import Main from "./componets/Main";
import UserSpace from "./componets/UserSpace";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./componets/Login";
import AboutMe from "./componets/AboutUs";
import ProtectedRoutes from "./services/ProtectedRoutes";
import Footer from "./componets/Footer";
import ContacUS from "./componets/ContacUS";
import ViewProducts from "./componets/ViewProducts";

function App() {
  return (
    <BrowserRouter>
        <Header/>
      <Routes>
      <Route element={
      <>
      <Main/>
      <hr className="w3-opacity" />
      <AboutMe />
      <hr className="w3-opacity" />
      <ViewProducts />
      <hr className="w3-opacity" />
      <ContacUS />
      </>
       }
       path="/" exact
       />
        <Route path="/Login" element={<Login />} />
        {/* <Route path="/Products" element={<ViewProducts />} /> */}
        <Route element={<ProtectedRoutes />}>
          <Route element={<UserSpace />} path="/UserSpace" />
        <Route />
        </Route>
      </Routes>
       <Footer />
    </BrowserRouter>
  );
}

export default App;
